import Slider from 'components/slider';

// Большой слайдер
let slider = {};
const sliderWrap = document.querySelector('.j-first-screen-slider');

if (sliderWrap) {
    slider = new Slider();

    slider.init({
        slider        : sliderWrap,
        dots          : false,
        thumbnails    : false,
        arrow         : false,
        counter       : false,
        arrowPosition : 'caption',
        caption       : false,
        noSwipe       : true,
        autoplay      : true,
        autoplaySpeed : 5000,
        infinityLoop  : true,
        duration      : `1.5s`,
        animationDelay: 1500
    });
}
